import { TransmissionSystemOperatorResource } from 'app/_resources/transmission-system-operator.resource';
import * as angular from 'angular';

class LeadTimeSettingsComponentCtrl implements ng.IController {
    private settings: TsoSecondarySettingsDto;
    private authenticatedUser: LoginResult;

    constructor(
        private TransmissionSystemOperator: TransmissionSystemOperatorResource
    ) {}

    $onInit() {}

    public saveLeadTimeInformationNote(): ng.IPromise<any> {
        return this.TransmissionSystemOperator.saveSecondaryLeadTimeNote(
            { id: this.authenticatedUser.referenceId },
            this.settings.leadTimeDescription
        ).$promise;
    }
}

angular.module('app').component('pkpSecondaryLeadTimeNote', {
    controller: LeadTimeSettingsComponentCtrl,
    template:
        require('app/operator-settings-secondary-market/secondary-lead-time-note.component.html'),
    bindings: {
        settings: '=',
        authenticatedUser: '='
    }
});
